
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import axios from 'axios';
import Swal from 'sweetalert2';
import './plugin/toast.js';
import { route as ziggyRoute } from 'ziggy-js';
window.Swal = Swal;
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').content;

window.baseUrl = window.laravel?.baseUrl || window.location.origin;
window.route = ziggyRoute;

